import React, { useEffect } from "react";
import { Navigate, Outlet, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  DEFAULT_LOCALE,
  isSupportedLocale,
  persistLocale,
  stripLocaleFromPath,
  withLocale,
} from "./config";

export const LocaleLayout = () => {
  const { locale } = useParams();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (!isSupportedLocale(locale)) {
      return;
    }
    persistLocale(locale);
    document.documentElement.lang = locale;

    let cancelled = false;
    i18n.changeLanguage(locale).then(() => {
      if (!cancelled) {
        document.title = i18n.t("meta.documentTitle");
      }
    });

    return () => {
      cancelled = true;
    };
  }, [locale, i18n]);

  if (!isSupportedLocale(locale)) {
    const rest = stripLocaleFromPath(`/${locale}`);
    return <Navigate to={withLocale(rest, DEFAULT_LOCALE)} replace />;
  }

  return <Outlet />;
};
